import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Notifications from './components/Notifications';

const notifications = (props,{ t }) => (
  <Container>
    <Notifications {...props} />
  </Container>
);

notifications.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(notifications);
